/*
* store.js
*
* Description: Holds common/global Stores.
*
* This file is part of: "http://apps.sundair.com/", "SunCrew2 - Flights"
* Copyright 2018,2019,2020,2021,2022 Sundair GmbH
* Contact: http://www.sundair.com/
* @author Christian Arp <christian.arp@sundair.com>
* @author Learek <michael.broeker@sundair.com>
* @author Phillip Alsleben <phillip.alsleben@sundair.com>
*
*/
import Vue from 'vue';
import Vuex from 'vuex';
import flights from './modules/flights/flights'; // 'Store::Flights'
import blocktimes from './modules/blocktimes/blocktimes'; // 'Store::Blocktimes'
import airports from './modules/airports/airports'; // 'Store::Airports'
import slotmanagement from './modules/slotmanagement/slotmanagement'; // 'Store::Slotmanagement'
import shared from './modules/shared/shared'; // 'Store::Shared'

import * as getters from './getters'; // global ones
import * as mutations from './mutations';
import * as actions from './actions';

Vue.use(Vuex);


export const store = new Vuex.Store({
    state: {
        value: 0 // >>> just demo
    },
    getters,
    mutations,
    actions,
    modules: {
        //people,
        //hotels,
        // vacations,
        flights,
        blocktimes,
        airports,
        slotmanagement,
        shared
    }
});
